var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey darken-3 waggon-info-header-add",style:(`width: ${_vm.width};`)},[_c('v-icon',{staticClass:"ml-1 mr-1",attrs:{"color":"white"}},[_vm._v(" add ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }